// empty (null-loader)


//////////////////
// WEBPACK FOOTER
// ./src/style/style.sass
// module id = ./src/style/style.sass
// module chunks = 22676092666560